/**
 * @prettier
 */

import { useTranslation } from "react-i18next";
import { imageAlt } from "../../../config/accessabilityRules";
import { ACTION_LABELS } from "../../../config/dataDogActionLabels";
import CustomButton from "../../../components/CustomButton";
import { useRotatableImageContainer } from "./useRotatableImageContainer";

const ACTION = ACTION_LABELS.processResults;

const OutOfRetryAttemptsState = ({
    pageFocusRef,
    cardImage,
    proceedToNextStep,
    isTwoPagePassport = false,
}) => {
    const { t } = useTranslation();
    const { ImageContainer } = useRotatableImageContainer({
        isTwoPagePassport,
    });
    return (
        <>
            <h1
                className={"out-or-retry-attempts-heading"}
                ref={pageFocusRef}
                tabIndex={-1}
            >
                {t("idpal_ensure_all_text_is_visible")}
            </h1>
            <ImageContainer
                cardImage={cardImage}
                imageAltText={imageAlt.upLoadedDocument}
                src={cardImage}
            />
            <div className="document-review-cta-container">
                <CustomButton
                    id={"continue"}
                    className={"btn"}
                    label={t("idpal_submit")}
                    handleClick={() => proceedToNextStep()}
                    actionDataLabel={ACTION.continueButton}
                />
            </div>
        </>
    );
};

export default OutOfRetryAttemptsState;
